import { camelCase, pascalCase, paramCase, upperCase, lowerCase, titleCase, snakeCase } from '../../utils/changeCase';
import { IExecutionOptions, IQueryOptions } from '../../models/query';
import { BaseTransform } from './BaseTransform';

export class CaseTransform extends BaseTransform {
	execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions) {
		let response: any = queryResponse;
		const { caseType } = this.options;
		if (queryResponse && caseType) {
			response = queryResponse.toString();
			switch (caseType) {
				case 'camel':
					response = camelCase(response);
					break;
				case 'lower':
					response = lowerCase(response);
					break;
				case 'param':
					response = paramCase(response);
					break;
				case 'pascal':
					response = pascalCase(response);
					break;
				case 'title':
					response = titleCase(response);
					break;
				case 'upper':
					response = upperCase(response);
					break;
				case 'snake':
					response = snakeCase(response);
					break;
				default:
					break;
			}
		}
		return response;
	}
}